import React, { useState, useEffect, useRef } from 'react';
import { apis } from '../../services/Api';
import { getToken, isLogin, clearLocalStorage } from '../../services/Auth';
import logo from '../../assets/images/harbinger-systems-whitelogo.png'
import bell from '../../assets/images/notificationwhite.svg'
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { addNotificationsCount, addUser } from '../../actions/SkillAction';
import './headerstyle.css';


function Header(props) {

    let iframeRef = useRef(null);

    const location = useLocation();

    let [links] = useState([
        {
            id: 1,
            name: "Home",
            to: "/",
            className: "Nav-item"
        },
        {
            id: 2,
            name: "My Learnings",
            to: "/my-learning",
            className: "Nav-item"
        },
        {
            id: 3,
            name: "Catalog",
            to: "/catalog",
            className: "Nav-item"
        }
    ]);
    const history = useHistory();
    const stringReplace = (data) => {
        //console.log(data);
        let message = data.attributes.message;
        //remove all { & } from string
        message = message.replace(/[{}]/g, "");
        //replace string like name0, name1, name2 with modelNames
        for (let y = 0; y < data.attributes.modelNames.length; y++) {
            message = message.replace("name" + y, `<strong> ${data.attributes.modelNames[y]} </strong>`);
        }
        return message;
    }

    const readNotification = () => {
        if (!isLogin()) return;
        props.addNotificationsCount(0);
        props.notifications.forEach((e) => {
            if (!e.attributes.read)
                apis.patchUserNotifications(getToken().user_id, e);
        });
    }

    const logOut = async () => {
        clearLocalStorage();
        props.addUser(null);
        history.push({
            pathname: `/login`
        });
    }

    const goToProfile = () => {
        history.push({
            pathname: `/profile`
        });
    }

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        //console.log(string, results)
    }

    const handleOnHover = (result) => {
        // the item hovered
        //console.log(result)
    }

    const handleOnSelect = (item) => {
        // the item selected
        //console.log(item)
        history.push({
            pathname: `/course-details`,
            state: {
                cid: item.id
            }
        });
    }

    //when page nave change , this function clear search text.
    useEffect(() => {
        //console.log("page re direct");
        var inputNodes = document.querySelector(".sc-htpNat");
        if (!inputNodes) return;
        //console.log(inputNodes);
        inputNodes.click();
    }, [location]);

    const handleOnFocus = () => {
    }

    const formatResult = (item) => {
        //console.log(item)
        return item
        // return (<p dangerouslySetInnerHTML={{__html: '<strong>'+item+'</strong>'}}></p>); //To format result as html
    }

    return (
        <React.Fragment>
            <div className="App">
                <header className='fixed-top'>
                    <nav className="navbar navbar-expand-lg navbar-light w100">
                        <div className=" row heder-block">
                            <div className='col-lg-6 col-md-11 col-sm-11 logo-block'>
                                <NavLink className="navbar-brand" to={"/"}>
                                    <img className='logoImg' src={logo} />
                                </NavLink>
                                <form className="search-block mob" id="create-course-form">
                                    <div ref={iframeRef}>
                                        <ReactSearchAutocomplete
                                            items={props.courses}
                                            onSearch={handleOnSearch}
                                            onHover={handleOnHover}
                                            onSelect={handleOnSelect}
                                            onFocus={handleOnFocus}
                                            autoFocus
                                            formatResult={formatResult}
                                            value={"gg"}
                                        />
                                    </div>
                                </form>
                            </div>
                            {props.user &&
                                <div className='col-lg-6 col-md-1 col-sm-1'>
                                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                        <form className="search-block" id="create-course-form"> <div ref={iframeRef}>
                                            <ReactSearchAutocomplete
                                                items={props.courses}
                                                onSearch={handleOnSearch}
                                                onHover={handleOnHover}
                                                onSelect={handleOnSelect}
                                                onFocus={handleOnFocus}
                                                autoFocus
                                                formatResult={formatResult}
                                                value={"gg"}
                                            />
                                        </div>
                                        </form>
                                        <div className='dropdown-block mob-profile' onClick={() => readNotification()}>
                                            {props.user &&
                                                <nav className='menu-block mob'>
                                                    <div className='container'>
                                                        <ul className="nav-block PrimaryNav with-indicator">
                                                            {links.map((link, i) => {
                                                                return (
                                                                    <li key={i}>
                                                                        <NavLink exact className="Nav-item" activeClassName="active" to={link.to} >{link.name}</NavLink>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>
                                                </nav>
                                            }
                                            <ul className="navbar-nav notification">
                                                <li className="nav-item dropdown">
                                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src={bell} />
                                                        {props.notificationsCount > 0 ? <span className='count'>{props.notificationsCount}</span> : ""}
                                                    </a>
                                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                        {props.notifications?.map((e, i) =>
                                                            <React.Fragment key={i}>
                                                                <li ><span className="dropdown-item" dangerouslySetInnerHTML={{ __html: stringReplace(e) }} ></span></li>
                                                                <li><hr className="dropdown-divider" /></li>
                                                            </React.Fragment>
                                                        )}
                                                    </ul>
                                                </li>
                                            </ul>
                                            <ul className="navbar-nav">
                                                <li className="nav-item dropdown">
                                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img className='profileimg' src={props.user?.attributes.avatarUrl} />
                                                    </a>
                                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                        <li><a className="dropdown-item cp" onClick={() => goToProfile()}>{props.user?.attributes.name}</a></li>
                                                        <li><hr className="dropdown-divider" /></li>
                                                        <li><a className="dropdown-item cp" onClick={() => logOut()}>Sign Out</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            }
                        </div>
                    </nav>
                </header>
                {props.user &&
                    <nav className='menu-block'>
                        <div className='container'>
                            <ul className="nav-block PrimaryNav with-indicator">
                                {links.map((link, i) => {
                                    return (
                                        <li key={i}>
                                            <NavLink exact className="Nav-item" activeClassName="active" to={link.to} >{link.name}</NavLink>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </nav>
                }
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        user: state.user,
        notifications: state.notifications,
        notificationsCount: state.notificationsCount,
        courses: state.courses
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addUser: (data) => dispatch(addUser(data)),
        addNotificationsCount: (data) => dispatch(addNotificationsCount(data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Header);